import React from 'react';
import styled from 'styled-components';
import Youtube from 'react-youtube';
const YoutubePlayer = styled(Youtube)(({ theme }) => `
    width: 100%;
    height: 100%;
    min-height: 332px;
    border-radius: ${theme.borderRadius.x8};
    background-color: transparent;

    ${theme.media.below('sm')} {
      min-height: 183px;
    }
  `);
export const VideoPlayer = ({ title, videoId }) => {
    return React.createElement(YoutubePlayer, { videoId: videoId, id: title });
};
//# sourceMappingURL=index.js.map